/**
 * ======================================
 * Mutation types for the auth module
 * ======================================
 *
 * The mutation types that are available
 * on the auth module.
 */

export const SET_LIST_INVENTORY = 'SET_LIST_INVENTORY';
export const SET_QUANTITY_INVENTORY = 'SET_QUANTITY_INVENTORY';

export default {
  SET_LIST_INVENTORY,
  SET_QUANTITY_INVENTORY,
};
